import React from 'react';
import { Checkbox, TextField } from 'wix-ui-tpa/cssVars';
import classNames from 'classnames';
import { classes as numberClasses } from '../number-input-field/number-input-field-wut.st.css';
import { classes as checkboxClasses } from '../checkbox-field/checkbox-field-wut.st.css';
import styles from './guest-input.module.scss';
export const GuestInputWUT = _ref => {
  let {
    label,
    guestLimit,
    repeatCount,
    onCheckboxChange,
    onNumberInputChange
  } = _ref;
  return guestLimit > 1 ? /*#__PURE__*/React.createElement(TextField, {
    type: "number",
    className: classNames(numberClasses.textField, numberClasses.theme, styles.numberInputContainer),
    value: repeatCount.toString(),
    min: 0,
    max: guestLimit,
    onChange: e => onNumberInputChange(e.target.value)
  }) : /*#__PURE__*/React.createElement(Checkbox, {
    className: classNames(checkboxClasses.root, checkboxClasses.checkbox),
    label: label,
    checked: !!repeatCount,
    onChange: _ref2 => {
      let {
        checked
      } = _ref2;
      return onCheckboxChange(checked);
    }
  });
};
//# sourceMappingURL=guest-input-wut.js.map